import { render, staticRenderFns } from "./DetailAnnouncement.html?vue&type=template&id=2fd8920a&scoped=true&"
import script from "./DetailAnnouncement.vue?vue&type=script&lang=js&"
export * from "./DetailAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./DetailAnnouncement.scss?vue&type=style&index=0&id=2fd8920a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8920a",
  null
  
)

export default component.exports